export default __webpack_public_path__ + "static/media/logo.1a94a9b0.png";